import { useEffect, useState } from "react";

export const useDexData = () => {
  const [blocks, setBlocks] = useState(undefined);
  const [config, setConfig] = useState({});

  useEffect(() => {
    const getData = () => {
      try {
        window.AP.confluence.getMacroData((macroData) => {
          if (!Object.keys(macroData || {}).length) {
            setBlocks(undefined);
            setConfig(undefined);
            return;
          }

          setBlocks([...JSON.parse(macroData.blocks)]);
          setConfig(JSON.parse(macroData.config));
        });
      } catch (error) {
        setBlocks(undefined);
        setConfig(undefined);
      }
    };

    getData();
  }, []);

  return {blocks, config};
};
